import { Input, InputProps } from 'antd';
import { useFormContext, Controller } from 'react-hook-form';
import { EyeFilled, EyeInvisibleOutlined } from '@ant-design/icons';
import { t } from 'i18next';

interface FormInputPasswordProps extends InputProps {
  name: string;
}

export const FormInputPassword = ({ name, defaultValue, ...props }: FormInputPasswordProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <Input.Password
          size="middle"
          placeholder={t('login.passwordTextPlaceholder')}
          iconRender={(visible) => (visible ? <EyeFilled /> : <EyeInvisibleOutlined />)}
          value={value}
          onChange={onChange}
          {...props}
        />
      )}
    />
  );
};
